import script from "./ProjectAmount.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectAmount.vue?vue&type=script&setup=true&lang=js"

import "./ProjectAmount.vue?vue&type=style&index=0&id=b8f70c7e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8f70c7e"]])

export default __exports__